import type { I18nKey } from './en';

/** Hinglish — conversational roman-script starter; falls back to English. */
export const hinglish: Partial<Record<I18nKey, string>> = {
  'app.tagline': 'Aapki kundli. Aapka Ally. Aapke log.',
  'tabs.charts': 'Kundli',
  'onb.name': 'Ally aapko kis naam se bulaye?',
  'onb.timeStatus': 'Aapka birth time',
  'onb.time.exact': 'Mujhe exact birth time pata hai',
  'onb.time.approx': 'Approximate time ya range pata hai',
  'onb.time.unknown': 'Birth time nahi pata',
  'onb.time.unknown.note':
    'Guess karne ki zaroorat nahi. Poore din ke liye jo reliable hai wahi calculate karenge — lagna aur houses tab tak blank rahenge jab tak time narrow na ho.',
  'chart.stable': 'Aapke time window mein stable',
  'chart.possible': 'Exact time pe depend karta hai',
  'chart.unavailable': 'Time narrow hone tak unavailable',
  'ally.placeholder': 'Apni kundli, patterns, logon ke baare mein poochho…',
  'common.continue': 'Aage badho',
};
